var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Modal, Container, Grid, Loader, TransitionablePortal, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { showModal, closeModal } from 'app/actions/modalActions';
import Render from 'components/Render';
import EmailVerificattion from './EmailVerification';
import Button from '../../components/Button/Button';
import SandboxList from '../SandboxList/SandboxList';
import Plus from '../../components/Icons/PlusIcon';
import Sidebar from '../Sidebar/Sidebar';
import SandboxCreateIndex from '../SandboxCreate/SandboxCreateIndex';
import { beginFetchSandbox, beginPollingSandbox, beginGetUseCases, } from 'app/actions/sandboxActions';
import SingleUseCaseModal from '../Modals/SingleUseCaseModal';
import styleConstants from '../../assets/styles/style-constants';
import { isEmailVerified } from 'app/helpers/userHelper';
import toastHelper from '../../helpers/toastHelper';
import urlActionHelper from '../../helpers/sandboxUrlActionHelper';
import AddToDesktopModal from '../Modals/AddToDesktopModal';
import BloomLaunchModal from '../SandboxList/ItemComponents/BloomLaunchModal';
import NeulerLaunchModal from '../SandboxList/ItemComponents/NeulerLaunchModal';
import NeodashLaunchModal from '../SandboxList/ItemComponents/NeodashLaunchModal';
import ToolsLaunchModal from '../SandboxList/ItemComponents/ToolsLaunchModal';
import WorkspaceLaunchModal from '../SandboxList/ItemComponents/WorkspaceLaunchModal';
var HomePage = /** @class */ (function (_super) {
    __extends(HomePage, _super);
    function HomePage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomePage.prototype.componentDidMount = function () {
        var _a = this.props, user = _a.user, handleBeginGetUseCases = _a.handleBeginGetUseCases, handleBeginFetchSandbox = _a.handleBeginFetchSandbox, sandbox = _a.sandbox;
        if (!user.accessToken || !isEmailVerified())
            return;
        handleBeginGetUseCases();
        handleBeginFetchSandbox(user.accessToken);
        // If Main is rendeded 2nd time (say after a redirect from /onboarding),
        // then urlActionHelper should run in here because componentWillReceiveProps will not be called
        if (sandbox && sandbox.items && sandbox.useCases) {
            urlActionHelper(sandbox.items, user.accessToken, sandbox.useCases);
        }
    };
    HomePage.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _a = this.props, handleCloseModal = _a.handleCloseModal, _b = _a.sandbox, isCreating = _b.isCreating, items = _b.items, isPolling = _b.isPolling, isAcceptingInvitation = _b.isAcceptingInvitation, useCases = _b.useCases, accessToken = _a.user.accessToken, handleBeginPollingSandbox = _a.handleBeginPollingSandbox, handleBeginFetchSandbox = _a.handleBeginFetchSandbox;
        // on running instances fetched
        if ((!items || !useCases) && nextProps.sandbox.items && nextProps.sandbox.useCases) {
            urlActionHelper(nextProps.sandbox.items, accessToken, nextProps.sandbox.useCases);
        }
        // Close all modals (create and singleUseCase) based on redux state
        if (isCreating && !nextProps.sandbox.isCreating && !nextProps.sandbox.isCreatingError) {
            handleCloseModal();
        }
        // Poll sandbox based on redux state
        if (nextProps.sandbox.shouldPoll && nextProps.sandbox.lastCreatedSandboxHash) {
            handleBeginPollingSandbox(accessToken, nextProps.sandbox.lastCreatedSandboxHash);
        }
        if (isAcceptingInvitation &&
            !nextProps.sandbox.isAcceptingInvitation &&
            !nextProps.sandbox.isAcceptingInvitationError) {
            handleBeginFetchSandbox(accessToken);
        }
        toastHelper(this.props, nextProps);
    };
    HomePage.prototype.render = function () {
        if (!isEmailVerified())
            return React.createElement(EmailVerificattion, null);
        var _a = this.props, isCreateModal = _a.isCreateModal, user = _a.user, _b = _a.sandbox, isFetching = _b.isFetching, items = _b.items, handleCloseModal = _a.handleCloseModal, handleShowCreateModal = _a.handleShowCreateModal, URLDesiredSandbox = _a.URLDesiredSandbox, isCreating = _a.isCreating, isPolling = _a.isPolling, isAddToDesktopModal = _a.isAddToDesktopModal, isBloomModal = _a.isBloomModal, isNeulerModal = _a.isNeulerModal, isNeodashModal = _a.isNeodashModal, isToolsModal = _a.isToolsModal, isWorkspaceModal = _a.isWorkspaceModal, modalData = _a.modalData;
        return (React.createElement("div", null,
            React.createElement(Helmet, null,
                React.createElement("title", null, "Home"),
                React.createElement("meta", { name: "description", content: "Neo4j sandbox" })),
            React.createElement(Render, { if: URLDesiredSandbox },
                React.createElement(SingleUseCaseModal, { open: !!URLDesiredSandbox, usecase: URLDesiredSandbox, onClose: function () { return handleCloseModal(); } })),
            React.createElement(Modal, { open: isBloomModal, size: "tiny", closeIcon: true, onClose: handleCloseModal },
                React.createElement(BloomLaunchModal, { sandbox: modalData.sandbox })),
            React.createElement(Modal, { open: isNeulerModal, size: "small", closeIcon: true, onClose: handleCloseModal },
                React.createElement(NeulerLaunchModal, { sandbox: modalData.sandbox })),
            React.createElement(Modal, { open: isToolsModal, size: "small", closeIcon: true, onClose: handleCloseModal },
                React.createElement(ToolsLaunchModal, { sandbox: modalData.sandbox })),
            React.createElement(Modal, { open: isWorkspaceModal, size: "small", closeIcon: true, onClose: handleCloseModal },
                React.createElement(WorkspaceLaunchModal, { sandbox: modalData.sandbox })),
            React.createElement(Modal, { open: isNeodashModal, size: "small", closeIcon: true, onClose: handleCloseModal },
                React.createElement(NeodashLaunchModal, { sandbox: modalData.sandbox })),
            React.createElement(Render, { if: !isFetching },
                React.createElement(TransitionablePortal, { open: isCreateModal, transition: { animation: 'scale', duration: 500 } },
                    React.createElement("div", { className: "position-fixed top-0 left-0 w-full bg-white", style: { height: '100vh' } },
                        React.createElement(SandboxCreateIndex, { onClose: handleCloseModal })))),
            React.createElement(Render, { if: isAddToDesktopModal },
                React.createElement(TransitionablePortal, { open: isAddToDesktopModal, transition: { animation: 'scale', duration: 500 } },
                    React.createElement(AddToDesktopModal, { onClose: handleCloseModal }))),
            React.createElement(Container, { className: "mt2" },
                React.createElement(Render, { if: !isFetching },
                    React.createElement(Popup, { content: "Please wait until your project is being created.", position: "right center", inverted: true, disabled: !isPolling, trigger: React.createElement("div", { style: { cursor: 'pointer', display: 'inline-block' } },
                            React.createElement(Button, { className: "mb3 font-regular", icon: React.createElement(Plus, { color: styleConstants.colors.info, size: 12, styles: { marginLeft: 0 } }), onClick: handleShowCreateModal, size: "small", iconBefore: true, labeled: true, disabled: isCreating || isPolling }, "New Project")) })),
                React.createElement(Render, { if: isFetching },
                    React.createElement(Grid, null,
                        React.createElement(Grid.Column, { className: "mt5" },
                            React.createElement("div", { className: "text-center", style: { marginTop: 24 } },
                                React.createElement(Loader, { active: true, inline: "centered", inverted: true }))))),
                React.createElement(Render, { if: !isFetching },
                    React.createElement(Grid, null,
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement(Render, { if: items && items.length > 0 },
                                React.createElement(SandboxList, { sandboxes: items, user: user }))),
                        React.createElement(Grid.Column, { width: 4 },
                            React.createElement(Sidebar, null)))))));
    };
    return HomePage;
}(React.PureComponent));
var mapStateToProps = function (state) {
    var sandboxItems = state.sandbox.items;
    // Changing the key value helps in rendering of the SandboxList component
    if (sandboxItems) {
        var terminateHashKey_1 = state.sandbox.terminateSandboxHashKey || 'neo4j'; // 'neo4j' is only avoid having null value
        var extendSandboxHashKey_1 = state.sandbox.extendSandboxHashKey || 'neo4j';
        sandboxItems = sandboxItems.map(function (d) { return (__assign(__assign({}, d), { key: d.sandboxHashKey +
                (terminateHashKey_1 === d.sandboxHashKey ? 'terminating' : '') +
                (extendSandboxHashKey_1 === d.sandboxHashKey ? 'extending' : '') +
                (d.status === 'PENDING' ? 'PENDING' : '') })); });
    }
    return {
        user: state.user,
        isCreating: state.sandbox.isCreating,
        isPolling: state.sandbox.isPolling,
        sandbox: __assign(__assign({}, state.sandbox), { items: sandboxItems }),
        isCreateModal: state.activeModal.type === 'create',
        URLDesiredSandbox: state.activeModal.type === 'urlDesiredModal' && state.activeModal.data.usecase,
        isAddToDesktopModal: state.activeModal.type === 'addToDesktop',
        isBloomModal: state.activeModal.type === 'bloomLaunch',
        isNeulerModal: state.activeModal.type === 'neulerLaunch',
        isNeodashModal: state.activeModal.type === 'neodashLaunch',
        isToolsModal: state.activeModal.type === 'toolsLaunch',
        isWorkspaceModal: state.activeModal.type === 'workspaceLaunch',
        modalData: state.activeModal.data,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    handleBeginFetchSandbox: function (accessToken) { return dispatch(beginFetchSandbox(accessToken)); },
    handleBeginPollingSandbox: function (accessToken, usecase) {
        return dispatch(beginPollingSandbox(accessToken, usecase));
    },
    handleBeginGetUseCases: function () { return dispatch(beginGetUseCases()); },
    handleShowCreateModal: function () { return dispatch(showModal({ type: 'create' })); },
    handleCloseModal: function () { return dispatch(closeModal()); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
